import Vue from 'vue'
import { hasPermission } from '../utils/permission.js';

export function authGuard(to, from, next) {
    if( Vue.$jwt.getToken() ){
        if ( hasPermission(to.name) ){
            next();
        } else {
            next('/erro/403');
        }
    } else {
        next('/login');
    }    
}

export function noAuthGuard(to, from, next) {
    if ( Vue.$jwt.getToken() ){
        next();
    } else {
        if( !Vue.$jwt.getToken() ){
            next();
        } else {
            next('/login');
        } 
    }   
}